import type { CoprincipalAccountSource } from "../store/schema/AccountSourceList";
import getCoprincipalAccounts, { ContractsSupportedFilter, StartupFilter, } from "./getCoprincipalAccounts";

/**
 * Finds coprincipal accounts whose authenticating user has the specified OID and tenant ID.
 * OID is not guaranteed to be globally unique, so the tenant ID is required to avoid collisions.
 * The situations where multiple accounts share the same OID+TID are those that involve shared resources as Accounts.
 * @param objectId The AAD Object ID (OID) of the authenticating user
 * @param tenantId The AAD Tenant ID of the authenticating user
 * @returns Matching CoprincipalAccountSource items, or an empty array if not found
 */
export default function getCoprincipalAccountsByOidAndTid(objectId: string, tenantId: string): CoprincipalAccountSource[] {
    if (!objectId || !tenantId) {
        return [];
    }
    
    const lowerId = objectId.toLowerCase();
    const lowerTid = tenantId.toLowerCase();
    return getCoprincipalAccounts(StartupFilter.StartingOrCompleteOrError, ContractsSupportedFilter.Any).filter(account => account.authenticatingUserIdentifiers?.objectId?.toLowerCase() === lowerId &&
        account.authenticatingUserIdentifiers?.tenantId?.toLowerCase() === lowerTid);
}
